import TwitterLogo from './TwitterLogo';

export default TwitterLogo;
